import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    GridContainerReport,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    formataReportCapacidadePoupancaNecessidadeAporteAposentadoria,
    formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaIdade,
    formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaTaxa,
    formataReportCapacidadePoupancaEconomiaInventarioCotacaoSeguroVidaInteira,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    calculaEconomiaInventario
} from '../estudo-form/EstudoServiceSucessaoVitalicia'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    calculaReport,
    ateMaisXAnos,
} from './EstudoService'



const EstudoFormCapacidadePoupanca = ({ values, report }) => {

    const reportCapacidadePoupanca = calculaReport(values, report)

    const classNameSemBg = 'pt-1 pb-1' + (reportCapacidadePoupanca ? ' mb--1' : '') 
    const classNameComBg = 'pt-1 pb-1' + (reportCapacidadePoupanca ? ' mb--2 mt--1' : '') // mudança fonte: tirou bg-tableRowBodyExibeTabela


    return (
        <DivFormEstudo>
            <GridContainerReport
                align='left'
            >
                <GridItem12
                    className={'mb-3 '+ CLASSNAME().formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaCabecalho}
                    align="center"
                >
                    {LABEL.capacidadePoupanca.toUpperCase() /* mudança fonte: uppercase*/}
                </GridItem12>

                <GridItem12
                    className={classNameComBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(LABEL.receitaMensalMediaAtual,
                        values.receitaMensalMediaAtual, reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameSemBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(LABEL.despesaMensalMediaAtual,
                        values.despesaMensalMediaAtual, reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameComBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(LABEL.capacidadePoupancaMensalMediaAtual,
                        values.capacidadePoupancaMensalMediaAtual, reportCapacidadePoupanca)}
                </GridItem12>

                {(values.taxaInflacaoAnual || values.taxaInflacaoAnualAposAposentadoria) &&
                !values.utilizarPercRentabilidadeAnualRecursosFinanceiros
                    ?
                        <>
                            <GridItem12
                                className={classNameSemBg}
                            >
                                {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaTaxa(
                                    LABEL.taxaJuros +
                                        (
                                            values.diferenciarTaxasAposAposentadoria
                                                ?
                                                    ' ' + LABEL.retornoRealAteAposAposentadoria
                                                :
                                                    ''
                                        ),
                                    values.taxaJurosAnual,
                                    (
                                        values.diferenciarTaxasAposAposentadoria
                                            ?
                                                values.taxaJurosAnualAposAposentadoria
                                            :
                                                ''
                                    ), 
                                    reportCapacidadePoupanca)}
                            </GridItem12>

                            <GridItem12
                                className={classNameComBg}
                            >
                                {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaTaxa(
                                    LABEL.taxaInflacao +
                                        (
                                            values.diferenciarTaxasAposAposentadoria
                                                ?
                                                    ' ' + LABEL.retornoRealAteAposAposentadoria
                                                :
                                                    ''
                                        ),
                                    values.taxaInflacaoAnual,
                                    (
                                        values.diferenciarTaxasAposAposentadoria
                                            ?
                                                values.taxaInflacaoAnualAposAposentadoria
                                            :
                                                ''
                                    ), 
                                    reportCapacidadePoupanca)}
                            </GridItem12>
                        </>
                    :
                        ''
                }

                <GridItem12
                    className={classNameSemBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaTaxa(
                        LABEL.retornoReal +
                            (
                                values.diferenciarTaxasAposAposentadoria
                                    ?
                                        ' ' + LABEL.retornoRealAteAposAposentadoria
                                    :
                                        ''
                            ),
                        values.taxaRetornoAnualRealPonderada,
                        (
                            values.diferenciarTaxasAposAposentadoria
                                ?
                                    values.taxaRetornoAnualRealAposAposentadoria
                                :
                                    ''
                        ), 
                        reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameComBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaIdade(LABEL.idadeVaiAposentar,
                        values.idadeVaiAposentarCliente, reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameSemBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaIdade(LABEL.idadeExpectativaVida,
                        values.idadeFinalVitalicioClienteConjuge, reportCapacidadePoupanca)
                    }
                </GridItem12>

                <GridItem12
                    className={classNameComBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(LABEL.valorPresenteReservaInicioAposentadoria,
                        values.valorPresenteReservaInicioAposentadoria, reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameSemBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(LABEL.valorPresenteNecessidadesInicioAposentadoria,
                        values.valorPresenteNecessidadesInicioAposentadoria, reportCapacidadePoupanca)}
                </GridItem12>

                <GridItem12
                    className={classNameComBg}
                >
                    {values.valorPresenteDeficitReservaInicioAposentadoria > 0
                        ?
                            formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(
                                LABEL.valorPresenteDeficitReservaInicioAposentadoria,
                                    values.valorPresenteDeficitReservaInicioAposentadoria * -1, reportCapacidadePoupanca)
                        :
                            formataReportCapacidadePoupancaNecessidadeAporteAposentadoria(
                                LABEL.valorPresenteSuperavitReservaInicioAposentadoria,
                                    values.valorPresenteSuperavitReservaInicioAposentadoria, reportCapacidadePoupanca)
                    }
                </GridItem12>
                
                <GridItem12
                    className={classNameSemBg}
                >
                    {formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaIdade(LABEL.idadeLimiteReservaAposentadoria,
                        ateMaisXAnos(values.recursosFinanceirosAcumuladosAposentadoriaIdadeAte, values.idadeExpectativaVidaCliente),
                            reportCapacidadePoupanca)
                    }
                </GridItem12>

                {values.exibirCapitalSeguradoCarteiraInvestimentos && existeTabelaEvolucaoValorResgate(values) &&
                values.premioVidaInteiraOriundoCarteiraInvestimentos && values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira &&
                pesquisaList(values.recursosFinanceiros, values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira)
                    .tipoRecursoFinanceiro !== HARDCODE.idTipoRecursoFinanceiroPrevidenciaPGBL &&
                pesquisaList(values.recursosFinanceiros, values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira)
                    .tipoRecursoFinanceiro !== HARDCODE.idTipoRecursoFinanceiroPrevidenciaVGBL && 
                !values.idadeSimularResgateVidaInteiraCliente &&
                !values.idadeSimularResgateVidaInteiraConjuge && (
                    <GridItem12
                        className={classNameSemBg}
                    >
                        {formataReportCapacidadePoupancaEconomiaInventarioCotacaoSeguroVidaInteira(LABEL.economiaInventarioCotacaoSeguroVidaInteira,
                            calculaEconomiaInventario(values,
                                values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge),
                                    reportCapacidadePoupanca)
                        }
                    </GridItem12>
                )}
            </GridContainerReport>
        </DivFormEstudo>
    )
}

export default EstudoFormCapacidadePoupanca